<div class="paginator-container" [class.hide-page-size]="hidePageSize()">
  @if (isVerySmall() && !hidePageSize()) {
    <mat-form-field appearance="outline" class="paginator-container__mobile">
      <mat-label>Page size</mat-label>
      <mat-select [value]="pageSize()" (selectionChange)="onPageSelectionChange($event)">
        @for (value of itemsPerPage(); track value) {
          <mat-option [value]="value">{{ value }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  } @else {
    <mat-paginator
      [length]="dataCount()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="itemsPerPage()"
      [pageIndex]="pageIndex() || 0"
      (page)="pageChange.emit($event)"
      [class.compact-paginator]="isSmall()"
    ></mat-paginator>
  }

  <mat-form-field class="paginator" appearance="outline">
    <mat-label>Page</mat-label>
    <input
      class="input-pageindex"
      matInput
      type="number"
      min="0"
      max="{{ maxPageIndex() }}"
      value="{{ (pageIndex() ?? 0) + 1 }}"
      (change)="pageIndexChange.emit($event)"
      (input)="getValueFromPageIndexInput($event)"
    />
    <span matTextSuffix
      >of {{ dataCount() === MAX_SAFE_INTEGER ? 'unknown' : maxPageIndex() }}</span
    >
  </mat-form-field>
</div>
